<template>
    <div class="card mb-4">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-3">
                    <h6>Gestión de Usuarios</h6>
                </div>

                <div class="col-md-6">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control"
                            v-model="searchTerm"
                            placeholder="Buscar por Nombre, Username, Email o Rol..."
                        />
                    </div>
                </div>

                <div class="col-md-3">
                    <argon-button color="success" size="sm" fullWidth @click="goToCreateUser">
                        <i class="fas fa-plus me-2"></i> Nuevo Usuario
                    </argon-button>
                </div>
            </div>
        </div>

        <div class="card-body px-0 pt-0 pb-2">
            <div v-if="isLoading" class="text-center py-5">
                Cargando usuarios y roles...
            </div>
            <div v-else class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Usuario</th>
                            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">Rol / Correo</th>
                            <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Estado</th>
                            <th class="text-center text-uppercase text-xxs font-weight-bolder opacity-7">Última Actualización</th>
                            <th class="opacity-7 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="filteredUsers.length === 0">
                            <td colspan="5" class="text-center py-4 text-muted">
                                {{ searchTerm ? 'No hay coincidencias con la búsqueda.' : 'No se encontraron usuarios.' }}
                            </td>
                        </tr>
                        <tr v-for="user in filteredUsers" :key="user.id">
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ user.full_name }}</h6>
                                        <p class="text-xs text-bold text-primary mb-0">@{{ user.username }}</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0">{{ user.role_name || 'Rol Desconocido' }}</p>
                                <p class="text-xs text-bold text-primary mb-0">{{ user.email }}</p>
                            </td>
                            <td class="align-middle text-center text-sm">
                                <span
                                    :class="[user.is_active === 1 ? 'badge-success' : 'badge-danger']"
                                    class="badge badge-sm"
                                >
                                    {{ user.is_active === 1 ? 'Activo' : 'Suspendido' }}
                                </span>
                            </td>
                            <td class="align-middle text-center">
                                <span class="text-primary text-xs font-weight-bold">
                                    {{ formatDate(user.updated_at) }}
                                </span>
                            </td>

                            <td class="align-middle text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <a
                                        @click="goToEditUser(user.id)"
                                        class="btn bg-success me-2"
                                        data-toggle="tooltip"
                                        data-original-title="Editar usuario"
                                    >
                                        <i class="fas fa-edit text-white text-sm opacity-10"></i>
                                    </a>

                                    <a
                                        @click="$emit('toggle-status', user)"
                                        :class="[user.is_active === 1 ? 'bg-danger' : 'bg-success']"
                                        class="btn mx-2"
                                        data-toggle="tooltip"
                                        :data-original-title="user.is_active === 1 ? 'Suspender Usuario' : 'Activar Usuario'"
                                    >
                                        <i :class="[user.is_active === 1 ? 'fas fa-times-circle' : 'fas fa-check-circle']" class="text-white text-sm opacity-10"></i>
                                    </a>

                                    <a
                                        @click="$emit('request-reset', user)"
                                        class="btn bg-warning mx-2"
                                        data-toggle="tooltip"
                                        data-original-title="Restablecer Contraseña"
                                    >
                                        <i class="fas fa-undo-alt text-white text-sm opacity-10"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from 'sweetalert2';
import axios from "axios";

export default {
    name: "UsersTable",
    components: { ArgonButton },
    // 🛑 Declaramos los eventos que se emitirán 🛑
    emits: ['toggle-status', 'request-reset'],

    data() {
        return {
            users: [], // Lista completa de usuarios
            roles: [], // Lista de roles para mapeo
            searchTerm: '',
            isLoading: true,
            branchId:parseInt(localStorage.getItem('branchId')),
            userRole:parseInt(localStorage.getItem('userLevel'))
        };
    },
    computed: {
        // Lógica de Filtrado Local (basada en el array 'users' interno)
        filteredUsers() {
            if (!this.searchTerm) {
                return this.users;
            }
            const searchLower = this.searchTerm.toLowerCase();
            return this.users.filter(user => {
                const fullName = (user.full_name || '').toLowerCase();
                const username = (user.username || '').toLowerCase();
                const email = (user.email || '').toLowerCase();
                const roleName = (user.role_name || '').toLowerCase();

                return fullName.includes(searchLower) ||
                       username.includes(searchLower) ||
                       email.includes(searchLower) ||
                       roleName.includes(searchLower);
            });
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return 'N/A';
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            return new Date(dateString).toLocaleDateString('es-ES', options);
        },

        goToCreateUser() {
            this.$router.push('/settings/users/create');
        },

        goToEditUser(id) {
            this.$router.push(`/settings/users/${id}`);
        },

        // === LÓGICA DE CARGA DE DATOS (Roles y Usuarios) ===
        async fetchData() {
            this.isLoading = true;
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };

            try {
                let qryParams;
                if(this.userRole==2){
                    qryParams='?fk_branch_id='+this.branchId;
                    console.log('soy coordinador')
                }else{
                    qryParams='?company='+localStorage.getItem('companyId');
                }
                const [usersResponse, rolesResponse] = await Promise.all([
                    axios.get(this.$store.state.apiURL + 'users'+qryParams, config),
                    axios.get(this.$store.state.apiURL + 'roles', config)
                ]);

                this.roles = rolesResponse.data;
                const rolesMap = new Map(this.roles.map(role => [role.id, role.name]));

                this.users = usersResponse.data.map(user => ({
                    ...user,
                    is_active: parseInt(user.is_active),
                    role_name: rolesMap.get(user.role_id) || 'Rol Desconocido'
                }));

            } catch (error) {
                console.error("Error al cargar datos:", error.response || error);
                this.handleSessionError(error);
            } finally {
                this.isLoading = false;
            }
        },
        // === FIN LÓGICA DE CARGA ===

        // Las funciones toggleUserStatus y requestPasswordReset fueron eliminadas
        // y reemplazadas por los emits en el template.

        handleSessionError(error) {
            const self = this;
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    confirmButtonColor:'#bf4f51',
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            }
        }
    },
};
</script>